import { render } from "./OptStatViewManagerAreaScreen.vue?vue&type=template&id=370aeedf&scoped=true"
import script from "./OptStatViewManagerAreaScreen.vue?vue&type=script&lang=js"
export * from "./OptStatViewManagerAreaScreen.vue?vue&type=script&lang=js"

import "./OptStatViewManagerAreaScreen.vue?vue&type=style&index=0&id=370aeedf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370aeedf"]])

export default __exports__